import React from 'react';
import { deburr } from 'lodash';
import { IconButton, Popper, Paper } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import Autosuggest from 'react-autosuggest';

import { sortingLowerCase } from '../../services/I2P2Helper';
import TextField from '../TextField/TextField';
import MenuItem from '../MenuItem/MenuItem';
import ListItemTip from './legacy/ListItemTip';

export const autosuggestStyles = {
  popper: {
    zIndex: 2,
  },
  itemStyle: {
    borderBottom: '1px solid rgb(240, 240, 240)',
  },
  itemId: {
    position: 'absolute',
    top: 0,
    color: 'gray',
    fontSize: '9px',
    marginLeft: '5px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  itemLabel: {
    position: 'absolute',
    bottom: 0,
  },
  container: {
    position: 'relative',
    width: '100%',
    height: '32px',
    marginTop: 16,
    marginBottom: 24,
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    zIndex: 2,
    left: 0,
    right: 0,
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
  },
};

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '32px',
  marginBottom: 39,
};

class RenderAutocomplete extends React.PureComponent {
  state = {
    value: '',
    dataSource: [],
    suggestion: null,
    disabled: this.props.disabled,
  };

  anchorEl = null;

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.input.value !== prevProps.input.value && !this.props.input.value) {
      this.onChangeNullCallback();
    }
  }

  onChangeCallback = (event, { suggestion }) => {
    const {
      input: { onChange },
    } = this.props;

    if (suggestion === null) {
      onChange(null);
    } else {
      this.setState({ suggestion, disabled: true });
      onChange(suggestion.value);
    }
  };

  onChangeNullCallback = () => {
    const {
      input: { onChange },
    } = this.props;

    this.setState({ suggestion: null, value: '', disabled: false });
    onChange(null);
  };

  handleChange =
    () =>
    (event, { newValue }) => {
      this.setState({ value: newValue });
    };

  getItemElement = (item, { isHighlighted }) => (
    <MenuItem selected={isHighlighted} style={autosuggestStyles.itemStyle} component="div">
      <ListItemTip optClass="faults-filter-cut" text={`${item.label || 'empty'}`} maxTextSize="23" hintText={`${item.label || 'empty'}`} />
    </MenuItem>
  );

  renderInputComponent = (inputProps) => {
    const { inputRef = () => {}, onBlur, onFocus, ref, ...other } = inputProps;
    const inputPropsValue = inputProps.value;
    const {
      input: { value },
    } = this.props;

    const error = this.props.meta.submitFailed && this.props.meta.error;

    const textfield = (
      <TextField
        {...other}
        disabled={this.state.disabled || this.props.readOnly}
        error={error}
        fullWidth
        InputProps={{
          onBlur,
          onFocus,
          inputRef: (node) => {
            ref(node);
            inputRef(node);
          },
        }}
      />
    );

    return inputPropsValue !== '' && value ? (
      <ListItemTip text={inputPropsValue} maxTextSize="23" hideHighlight hintText={inputPropsValue || 'empty'} child={textfield} />
    ) : (
      textfield
    );
  };

  shouldRenderSuggestions = () => true;

  getSuggestionValue = (suggestion) => suggestion.value;

  getSuggestions = ({ value }) => {
    const inputValue = deburr(value.trim()).toLowerCase();
    const inputLength = inputValue.length;

    const filteredSuggestions =
      inputLength === 0
        ? this.props.dataSource
        : this.props.dataSource.filter((suggestion) => suggestion.label.toLowerCase().includes(inputValue));

    this.setState({
      dataSource: filteredSuggestions,
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      dataSource: [],
    });
  };

  setAnchorEl = (node) => {
    this.anchorEl = node;
  };

  render() {
    const {
      input: { value, name },
      label,
      floatingLabelText,
      required,
      readOnly,
      disabled,
    } = this.props;
    const formattedLabel = label || floatingLabelText || '';
    const labelText = required ? (
      <span>
        {formattedLabel}
        <span className="required-asterisk">*</span>
      </span>
    ) : (
      formattedLabel
    );

    const isDisabled = this.props.disabled || this.props.readOnly;
    const options = this.state.dataSource.sort((a, b) => sortingLowerCase(a, b, 'label'));

    const disabledClassName = disabled ? 'disabled' : '';
    const selectedClassName = value ? 'selected' : '';
    const readOnlyClassName = readOnly ? 'read-only' : '';

    const wrapperClassName = `autocompleteWrapper ${disabledClassName} ${selectedClassName} ${readOnlyClassName}`;

    const inputProps = {
      placeholder: isDisabled ? '' : 'Start typing name',
      label: labelText,
      value: value || this.state.value,
      onChange: this.handleChange(value),
      inputRef: (node) => {
        this.setAnchorEl(node);
      },
      InputLabelProps: {
        shrink: true,
      },
    };

    const paperStyle = {
      maxHeight: '300px',
      overflowY: 'auto',
      width: this.anchorEl ? this.anchorEl.clientWidth : undefined,
    };

    return (
      <div data-field-name={`${name}`} className="contents">
        <div className={wrapperClassName}>
          <Autosuggest
            key={name}
            renderInputComponent={this.renderInputComponent}
            suggestions={options}
            focusInputOnSuggestionClick={false}
            onSuggestionsFetchRequested={this.getSuggestions}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.getItemElement}
            shouldRenderSuggestions={this.shouldRenderSuggestions}
            onSuggestionSelected={this.onChangeCallback}
            theme={{
              container: containerStyle,
              suggestionsContainerOpen: autosuggestStyles.suggestionsContainerOpen,
              suggestionsList: autosuggestStyles.suggestionsList,
              suggestion: autosuggestStyles.suggestion,
            }}
            renderSuggestionsContainer={(options) => (
              <Popper style={autosuggestStyles.popper} anchorEl={this.anchorEl} open={Boolean(options.children)}>
                <Paper square {...options.containerProps} style={paperStyle}>
                  {options.children}
                </Paper>
              </Popper>
            )}
            inputProps={inputProps}
          />
          {value && !readOnly ? (
            <IconButton size="large" className="resetOwnerButton" onClick={this.onChangeNullCallback}>
              <CloseIcon />
            </IconButton>
          ) : null}
        </div>
      </div>
    );
  }
}

export default RenderAutocomplete;
